import { usePartner } from '@/context/PartnerContext'
import { Button, HStack, Icon, Link, Stack, Text } from '@chakra-ui/react'
import { faExclamationCircle, faRefresh } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Sentry from '@sentry/react'
import { AuthPageLayout } from 'BrokerTsLib/src/components'
import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'

export const PoleasErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    Sentry.captureMessage('Error boundary reached.', {
      extra: {
        error
      },
      level: 'error'
    })
    console.error(error)
  }, [error])

  const { currentPartner } = usePartner()

  return <AuthPageLayout 
    title="Došlo k chybě"
    titleIcon={faExclamationCircle}
    logo={currentPartner?.logo}
  >
    <Stack mx='auto' gap={12}>
      <Text maxW='40ch' textAlign='center' fontSize='2xl'>
        Omlouváme se, ale při zpracování Vašeho požadavku nastal technický problém.
        <br />
        <br />
        Zkuste to prosím znovu později. 
        <br />
        Pokud potíže přetrvávají, kontaktujte naše klientské centrum na čísle <Link fontWeight="semibold" href="tel:+420844113355">844 11 33 55</Link>.
      </Text>
    
      <Button colorScheme="gray" variant='ghost' size='lg' mx="auto" onClick={() => window.location.reload()}>
        <HStack>
          <Icon as={FontAwesomeIcon} icon={faRefresh} />
          <span>Znovu načíst</span>
        </HStack>
      </Button>
    </Stack>
  </AuthPageLayout>
}